import { createAction, props } from '@ngrx/store';
import { BaseTag } from '@sleipai/sleip-models';

export const loadTags = createAction('[Tag] Load Tags');

export const loadTagsSuccess = createAction(
  '[Tag] Load Tags Success',
  props<{ tags: { [category: string]: { [id: string]: BaseTag } } }>()
);

export const loadTagsFailure = createAction(
  '[Tag] Load Tags Failure',
  props<{ error: any }>()
);
